import { qrcode } from '@bwip-js/browser'

import type { TicketElement } from '../TicketElement'

export class QR implements TicketElement {
  code: string
  barcodeHeight: number

  constructor(code: string, { height }: { height?: number } = {}) {
    this.code = code
    this.barcodeHeight = height || 120
  }

  height(): number {
    return this.barcodeHeight
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    const canvas = document.createElement('canvas')
    qrcode(canvas, {
      bcid: 'qrcode',
      text: this.code,
      scaleX: 1,
      scaleY: 1,
      width: this.barcodeHeight,
      height: this.barcodeHeight
    })
    const paddingLeft = (width - this.barcodeHeight) / 2
    ctx.drawImage(canvas, paddingLeft, top, this.barcodeHeight, this.barcodeHeight)
  }
}
